var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Careers"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 4165,
    transform: "translate(-136 -3837)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "footer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mdi:location"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.00016 7.66659C7.55814 7.66659 7.13421 7.49099 6.82165 7.17843C6.50909 6.86587 6.3335 6.44195 6.3335 5.99992C6.3335 5.55789 6.50909 5.13397 6.82165 4.82141C7.13421 4.50885 7.55814 4.33325 8.00016 4.33325C8.44219 4.33325 8.86611 4.50885 9.17867 4.82141C9.49123 5.13397 9.66683 5.55789 9.66683 5.99992C9.66683 6.21879 9.62372 6.43552 9.53996 6.63772C9.4562 6.83993 9.33344 7.02367 9.17867 7.17843C9.02391 7.33319 8.84018 7.45596 8.63797 7.53972C8.43576 7.62348 8.21903 7.66659 8.00016 7.66659ZM8.00016 1.33325C6.76249 1.33325 5.5755 1.82492 4.70033 2.70009C3.82516 3.57526 3.3335 4.76224 3.3335 5.99992C3.3335 9.49992 8.00016 14.6666 8.00016 14.6666C8.00016 14.6666 12.6668 9.49992 12.6668 5.99992C12.6668 4.76224 12.1752 3.57526 11.3 2.70009C10.4248 1.82492 9.23784 1.33325 8.00016 1.33325Z",
    fill: "white"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.667b0e41a1b8627999e6437b1fedc783.svg";
export { ForwardRef as ReactComponent };